/* Produkt-Videos (Mood-Videos): nur abspielen, solange sichtbar.
   Spart Datenvolumen (preload="none") und respektiert «Bewegung reduzieren». */
(function () {
  'use strict';
  var vids = document.querySelectorAll('[data-pvideos] .pvideos__video--auto');
  if (!vids.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    /* Kein Autoplay → normale Steuerung anbieten */
    vids.forEach(function (v) { v.controls = true; });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        /* Falls der Browser Autoplay blockiert: Steuerung einblenden */
        if (p && p.catch) p.catch(function () { v.controls = true; });
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.35 });

  vids.forEach(function (v) {
    v.muted = true;
    io.observe(v);
  });
})();
